export interface IGetUsersRequest {
  firstName: string;
  lastName: string;
  skip: number;
  take: number;
}

export class GetUsersRequest implements IGetUsersRequest {
  firstName: string;
  lastName: string;
  skip: number;
  take: number;
}
